// Types
export interface Category {
  name: string;
  color: string;
  description?: string;
}

/**
 * Restrained Bilt chrome accents — warm neutrals + orange family.
 * Avoid saturated purple/pink for interactive surfaces.
 */
export const categories: Category[] = [
  { name: 'Engine', color: '#F97316', description: 'Internal engine components, pistons, rods, etc.' },
  { name: 'Turbo', color: '#EA580C', description: 'Turbocharger, intercooler, piping' },
  { name: 'Drivetrain', color: '#FB923C', description: 'Transmission, diffs, axles, clutch' },
  { name: 'Fuel System', color: '#D97706', description: 'Injectors, fuel pump, lines, rails' },
  { name: 'Cooling', color: '#78716C', description: 'Radiator, fans, cooling system' },
  { name: 'Suspension', color: '#A8A29E', description: 'Coilovers, springs, sway bars' },
  { name: 'Brakes', color: '#E11D48', description: 'Brake pads, rotors, calipers' },
  { name: 'Wheels', color: '#9A3412', description: 'Wheels, tires, wheel hardware' },
  { name: 'Exhaust', color: '#C2410C', description: 'Exhaust system, downpipe, catback' },
  { name: 'Interior', color: '#57534E', description: 'Seats, gauges, interior modifications' },
  { name: 'Exterior', color: '#B45309', description: 'Body kit, spoilers, exterior mods' },
  { name: 'Electronics', color: '#F59E0B', description: 'ECU, wiring, sensors, electronics' },
  { name: 'Miscellaneous', color: '#6B7280', description: 'Other modifications and services' },
];

export const getCategoryColor = (categoryName: string): string => {
  const category = categories.find((cat) => cat.name === categoryName);
  return category?.color || '#6B7280';
};

export const getCategoryNames = (): string[] => {
  return categories.map((cat) => cat.name);
};
